import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/marketing/Navbar";
import { useAuth } from "../context/AuthContext";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const { signIn } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await signIn({ email, password: pw });
      nav("/app");
    } catch (ex) {
      const detail = ex?.response?.data?.detail;
      if (Array.isArray(detail)) {
        setErr(detail.map(e => e.msg).join(", "));
      } else if (typeof detail === "string") {
        setErr(detail);
      } else {
        setErr("Sign in failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-16">
        <h1 className="font-display text-4xl">Welcome back.</h1>
        <p className="text-[#3f4a44] mt-2 text-sm">Sign in to your Full Bench workspace.</p>

        <form onSubmit={submit} className="mt-8 space-y-4 bg-white p-6 rounded-xl border border-cream">
          <label className="block text-sm">
            <span className="font-medium">Email</span>
            <input
              data-testid="signin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40"
            />
          </label>
          <label className="block text-sm">
            <span className="font-medium">Password</span>
            <input
              data-testid="signin-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40"
            />
          </label>
          {err && <div data-testid="signin-error" className="text-xs text-red-600">{err}</div>}
          <button data-testid="signin-submit" type="submit" disabled={loading} className="btn-coral w-full py-2.5 rounded-md text-sm font-medium">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-sm text-center mt-4 text-[#3f4a44]">
          No account? <Link to="/signup" className="text-coral font-medium">Try Full Bench free</Link>
        </p>
      </div>
    </div>
  );
}
